import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import Cropper from "react-easy-crop";

const CropImageModal = ({
  show,
  handleClose,
  imageSrc,
  onCropComplete,
  aspect = 1,
  saveCroppedImage,
}) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const handleCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
    if (onCropComplete) onCropComplete(croppedArea, croppedAreaPixels);
  };

  const handleSave = () => {
    saveCroppedImage(croppedAreaPixels);
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Crop Image</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div
          style={{ position: "relative", height: "400px", background: "#333" }}
        >
          <Cropper
            image={imageSrc}
            crop={crop}
            zoom={zoom}
            aspect={aspect}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={handleCropComplete}
          />
        </div>
        <div className="d-flex justify-content-center mt-3">
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            className="ms-2"
            onClick={handleSave}
            style={{ background: "#ff6004", border: "1px solid #ff6004" }}
          >
            Save
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CropImageModal;
